import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaTimes, FaCalendarAlt, FaBullhorn } from 'react-icons/fa';
import './Updates.css';

function Updates() {
  const [tab, setTab] = useState('latest');
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    axios.get('https://api.hospifylink.com/api/updates', { params: { type: tab } })
      .then(r => { if (Array.isArray(r.data)) setItems(r.data); })
      .catch(() => {});
  }, [tab]);

  return (
    <section className="updates-root">
      <div className="updates-head">
        <h2 className="lca-section-title">Latest Updates</h2>
        <p className="lca-section-sub">What's new and what's coming next at Hospify Link</p>

        <div className="updates-tabs">
          <button
            className={`updates-tab ${tab === 'latest' ? 'active' : ''}`}
            onClick={() => setTab('latest')}>
            <FaBullhorn /> Latest
          </button>
          <button
            className={`updates-tab ${tab === 'upcoming' ? 'active' : ''}`}
            onClick={() => setTab('upcoming')}>
            <FaCalendarAlt /> Upcoming
          </button>
        </div>
      </div>

      <div className="updates-grid">
        {items.length === 0 && (
          <p className="updates-empty">No {tab} updates at the moment.</p>
        )}
        {items.map(it => (
          <div key={it.id} className="update-card" onClick={() => setSelected(it)}>
            <div className="update-card-img">
              <img src={it.image || 'https://via.placeholder.com/400'} alt={it.title} />
              <span className={`update-badge ${it.type}`}>{it.type}</span>
            </div>
            <div className="update-card-body">
              <h3>{it.title}</h3>
              <p>{it.description}</p>
              <span className="update-card-cta">Read more →</span>
            </div>
          </div>
        ))}
      </div>

      {selected && (
        <div className="update-modal-overlay" onClick={() => setSelected(null)}>
          <div className="update-modal" onClick={e => e.stopPropagation()}>
            <button className="update-modal-close" onClick={() => setSelected(null)}>
              <FaTimes />
            </button>
            <img src={selected.image} alt={selected.title} className="update-modal-img" />
            <div className="update-modal-body">
              <span className={`update-badge ${selected.type}`}>{selected.type}</span>
              <h2>{selected.title}</h2>
              <p className="update-modal-desc">{selected.description}</p>
              <p className="update-modal-long">{selected.long_description}</p>
              <small>
                Posted {selected.created_at
                  ? new Date(selected.created_at).toLocaleDateString('en-US', {
                      year: 'numeric', month: 'long', day: 'numeric'
                    })
                  : ''}
              </small>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Updates;